var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('modal',{attrs:{"id":"support-form-modal","title":"Contact Our Support Team"}},[_c('support-form',{attrs:{"on-submit-success":_vm.handleFormSubmitSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }